import * as React from 'react';
import classnames from 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '../../../../ProductBlock/types.js';
import '../../../../ProductBlock/utils/get-variant-images.js';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/api-client';
import { BannerRecommendationContainer } from '../../BannerRecommendationContainer.js';
import 'motion/react';

const BannerRecommendationBlock = ({ recommendation , showAsCard , className , tabIndex ,  })=>{
    return /*#__PURE__*/ React.createElement(BannerRecommendationContainer, {
        recommendation: recommendation,
        className: classnames(className, 'banner-recommendation-block', {
            'banner-recommendation-block--card': showAsCard
        }),
        tabIndex: tabIndex
    });
};

export { BannerRecommendationBlock };
//# sourceMappingURL=BannerRecommendationBlock.js.map
